import {
  adminArchivedToggleCommon,
  adminBatchCommon,
  adminBatchSelectionCommon,
} from "./exam-admin-common";

export const examAdminQuestions = {
  pageTitle: "题库中心",
  pageSubtitle: "按题型使用可视化表单录入题目，系统自动生成题目编号和结构化数据。",
  createQuestion: "新建题目",
  createSuccess: "题目创建成功",
  deleteSuccess: "题目删除成功",
  searchPlaceholder: "按题号或题干搜索",
  stemSummary: "题干摘要",
  createTitlePrefix: "新建",
  createFallbackTypeName: "题目",
  ...adminArchivedToggleCommon,
  statusUpdated: "题目状态已更新",
  archivedSuccess: "题目已归档",
  summaryTotal: "题目总数：{count}",
  summarySelected: "已选题目：{count}",
  overview: {
    total: "题目总数",
  },
  taskEditor: {
    createTitle: "新建题目",
    editTitle: "编辑题目",
    saveFirstToDebug: "请先保存题目，再在调试工作台进行完整调试。",
    viewModeDebugHint: "当前是查看模式。点击右上角“编辑”后可使用调试工作台。",
    runExecStatus: "运行状态",
    runCaseStatus: "用例结果",
    runExecPass: "运行成功",
    runExecFail: "运行失败",
    candidateRunPass: "通过",
    candidateRunFail: "未通过",
    unsavedLeaveConfirm: "当前有未保存变更，确认离开吗？",
    tabs: {
      config: "配置",
      examView: "考生视角",
      fullInfo: "完整信息",
      versionHistory: "版本历史",
      debug: "调试",
      versions: "版本",
    },
  },
  messages: {
    selectDraftsToPublish: "仅草稿题目可发布，请重新选择",
    selectArchivableToArchive: "当前未选中可归档题目",
    selectDraftsToDelete: "仅草稿题目可删除，请重新选择",
    batchPublished: "已发布 {count} 道题目",
    batchArchived: "已归档 {count} 道题目",
    batchDeleted: "已删除 {count} 道草稿题目",
  },
  batchSelection: adminBatchSelectionCommon,
  confirmArchiveSingle: {
    title: "确认归档该题目？",
    description: "归档后默认不在常用列表展示。",
  },
  confirmBatch: {
    publishDraftsTitle: "确认发布选中的 {count} 道草稿题目？",
    archiveTitle: "确认归档选中的 {count} 道题目？",
    deleteDraftsTitle: "确认删除选中的 {count} 道草稿题目？",
    deleteDraftsDescription: "删除后无法恢复。",
    archiveDescription: "归档后默认不在常用列表展示。",
  },
  batch: {
    ...adminBatchCommon,
    confirmPublishDraftsTitle: "确认批量发布当前选中草稿题目？",
    confirmArchiveTitle: "确认批量归档当前选中题目？",
    confirmDeleteDraftsTitle: "确认批量删除当前选中草稿题目？",
    publishAction: "发布",
  },
  drawerTitleCreate: "新建题目",
  previewTitle: "题目预览（考生视角）",
  codeRulePrefix: "题目编号由系统在首次保存成功后自动生成，格式为",
  codeRulePattern: "Q-题型字母-年周-序号",
  codeRuleSuffix: "，生成后不可修改。",
  stats: {
    total: "总题数：{count}",
    published: "已发布：{count}",
    draft: "草稿：{count}",
    summaryUnavailable: "题目图例计数加载失败，图例计数暂不可用",
  },
  table: {
    code: "题目编号",
    title: "标题",
  },
  confirmDelete: {
    title: "确认删除这个题目吗？",
    description: "仅未被试卷或作答引用的题目允许删除。",
  },
  preview: {
    unnamedTitle: "未命名题目",
    emptyStem: "暂无题干",
    judgmentTrue: "正确",
    judgmentFalse: "错误",
    shortAnswerPlaceholder: "考生将在此输入简答内容",
    codePlaceholder: "考生将在此编写代码",
    publicCases: "示例 / 公开用例",
    noPublicCases: "暂无公开用例",
    caseTitle: "用例 {index}",
    input: "输入：",
    output: "输出：",
    explanation: "说明：",
    practicalDescription: "该题为实操题，考生进入后可创建环境并按要求完成操作。",
    accessHint: "访问说明：{value}",
    noAccessHint: "暂无",
    attackDefenseAttachmentDescription: "该题为附件类夺旗题，请下载附件后本地分析并提交 flag。",
    attachmentAssets: "附件资源：{value}",
    noAssets: "暂无",
    flagPlaceholder: "考生将在此输入 flag，例如 flag{...}",
  },
  editor: {
    sections: {
      choiceAnswer: "选项与答案",
      referenceAnswerPoints: "参考答案与评分要点",
      judgeConfig: "判题配置",
      environmentConfig: "环境配置",
      attackDefenseConfig: "夺旗配置",
      aiMeta: "AI 元信息",
      structuredPreview: "结构化预览",
    },
    labels: {
      taskTitle: "题目名称",
      taskDescription: "题目描述",
      correctAnswerMultiple: "正确答案（可多选）",
      internalNote: "备注（仅出题人/管理员可见）",
      tags: "题目标签",
      knowledgePoints: "题目知识点",
      aiSource: "AI 来源",
      aiGenerated: "AI 生成标记",
      effectivePorts: "生效端口",
      image: "镜像标识",
      publicCase: "示例/公开用例",
      hiddenCase: "隐藏用例",
    },
    objects: {
      choiceOption: "选项",
      keyword: "关键词",
      scoringPoint: "得分点",
      publicCase: "示例/公开用例",
      hiddenCase: "隐藏用例",
      experienceEnvironment: "体验环境",
      temporaryEnvironment: "临时环境",
    },
    actions: {
      aiFill: "AI 填充",
      manualAdd: "手动新增",
      selectFromImageList: "从镜像列表选择",
      select: "选择",
      uploadAssetToLibrary: "上传附件到资产库",
    },
    messages: {
      required: "不能为空",
      selectQuestionType: "请选择题型",
      inputTitle: "请输入题目标题",
      inputStem: "请输入题干",
      inputOptionText: "请输入选项文案",
      selectCorrectAnswer: "请选择正确答案",
      selectAtLeastOneLanguage: "至少选择一种语言",
      inputCaseInput: "请输入输入示例",
      inputCaseOutput: "请输入期望输出",
      selectImage: "请选择镜像标识",
      selectContainerPort: "请选择容器端口",
      inputStandardFlag: "请填写标准 Flag",
      requireInitScriptForDynamicFlag: "动态 Flag 模式下请填写初始化脚本",
      selectAtLeastOneAttachment: "请至少选择一个附件",
      uploadAssetSuccess: "附件上传成功：{filename}",
      uploadAssetFailed: "附件上传失败",
      noUsableAnalysis: "AI 未返回可用的解析内容，请稍后重试或手动填写",
      analysisFilled: "AI 已填充解析说明",
      analysisFailed: "AI 生成解析失败",
      noUsableTags: "AI 未返回可用标签，请稍后重试或手动填写",
      tagsFilled: "AI 已填充标签",
      tagsFailed: "AI 生成标签失败",
      noUsableKnowledgePoints: "AI 未返回可用知识点，请稍后重试或手动填写",
      knowledgePointsFilled: "AI 已填充知识点",
      knowledgePointsFailed: "AI 生成知识点失败",
    },
    placeholders: {
      title: "输入题目标题",
      stem: "输入题干、背景描述或操作要求",
      referenceAnswer: "输入参考答案或评分参考",
      keywordExample: "例如：SQL 注入、参数化查询",
      pointExample: "例如：指出风险、给出修复方案",
      languageExample: "例如 python, java, cpp",
      starterCode: "输入默认模板代码",
      codeCaseInputExample: "例如：3 5（两个参数可用空格分隔；也可换行输入）",
      codeCaseOutputExample: "例如：8",
      executionHintExample: "例如：使用标准输入输出，禁止访问网络",
      image: "请选择镜像标识",
      containerPort: "请选择容器端口",
      imageKeyword: "输入镜像名称或镜像标识筛选",
      attachment: "请选择附件",
      analysis: "输入题目解析、注意事项或参考思路",
      internalNote: "内部备注，不会在考试端展示",
      tagsExample: "例如：安全、数据库、容器",
      knowledgePointsExample: "例如：SQL 注入、防火墙策略",
      aiSource: "例如：AI任务 #123（百炼） / 人工修订",
    },
    hints: {
      imageListEmpty: "请先到镜像管理中拉取可用镜像。",
      imageListManaged: "镜像列表来自镜像管理，仅可选择已维护的镜像标识。",
      imageListManagedShort: "镜像列表来自镜像管理（按镜像标识选择）。",
      imagesLoading: "镜像加载中",
      noImagesAvailable: "暂无可用镜像，请先到镜像管理中拉取",
      imagePicker: "支持在弹窗中按镜像名称或镜像标识筛选，并回填“镜像标识”字段。",
      noDeclaredPortWithGovernance: "当前镜像未声明端口，请更换镜像或先在镜像治理中补充 EXPOSE。",
      noDeclaredPort: "当前镜像未声明端口，请更换镜像或补充 EXPOSE。",
      practicalInitScript:
        "脚本提示：平台在容器内以 `sh -s` 执行脚本；常用目录建议使用 `/workspace`，并确保脚本可重复执行（幂等）。",
      callbackMode: "回调模式下不需要平台侧检查脚本，镜像内程序应主动回调平台报告完成状态。",
      practicalCheckScript:
        "检查脚本约定：退出码 `0` 视为通过，非 `0` 视为失败；建议在失败路径输出明确错误信息到 stderr。",
      hiddenCasesForJudge: "隐藏用例用于最终评判，不在考生端展示。",
      dynamicFlagContainerOnly: "动态 Flag 依赖环境实例生成与注入，载体固定为容器模式。",
      attackInitScript:
        "约定：启动流程应固化在镜像中；初始化脚本用于题目实例级准备。动态 Flag 模式下此脚本必填。",
      assetSource: "附件来源于资产模块，可多选。",
      attachmentMode: "附件模式用于静态分析类题目。上传后可直接在下拉中选择资产。",
      dynamicFlagValidation:
        "动态 Flag 会在环境实例创建时按考生身份生成并注入容器环境变量；平台仅保存哈希用于校验。",
      aiSourceExtra:
        "记录这段内容来自哪次 AI 任务或人工修订来源，例如：AI任务 #123（百炼）或 人工修订",
      structuredPreview:
        "当前页面以表单录入为主，系统会自动生成结构化 JSON。下方预览仅用于核对最终持久化内容。",
      practicalEditor: "用于边编辑边验证初始化脚本和检查脚本。创建环境后会自动执行一次初始化脚本。",
    },
    enums: {
      environmentType: {
        virtualMachine: "虚拟机",
      },
      checkMode: {
        exec: "容器外 exec 检测",
        callback: "容器内 callback 上报",
      },
    },
    switches: {
      aiGenerated: "AI 生成",
      manualCreated: "人工创建",
    },
    scripts: {
      practicalCheckExample:
        '#!/bin/sh\nset -eu\n\n# 检查关键文件是否存在\ntest -f /workspace/app/answer.txt\n\n# 检查文件内容是否符合要求\nexpected="hello-exam"\nactual="$(cat /workspace/app/answer.txt)"\n[ "$actual" = "$expected" ]',
      attackInitExample:
        '#!/bin/sh\nset -eu\n\n# 启动脚本由镜像内 ENTRYPOINT/CMD 负责，这里仅做题目实例初始化。\n# 示例：把动态 flag 写入应用读取位置（按你的镜像结构调整）\nmkdir -p /workspace\necho "$EXAM_DYNAMIC_FLAG" > /workspace/flag.txt',
    },
    ai: {
      sourceFormat: "AI任务 #{taskId}（{mode}）",
      modes: {
        bailian: "百炼",
        placeholder: "规则生成",
        placeholderFallback: "规则补全",
        local: "本地生成",
      },
    },
  },
} as const;
